import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLetterboxdComponent } from './simple-icons-letterboxd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLetterboxdComponent ],
    exports:      [ SimpleIconsLetterboxdComponent ],
    bootstrap:    []
})
export class SimpleIconsLetterboxdModule {}
